import { useState, useContext, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { AuthContext } from '../context/AuthContext';
import { Alert, Box, Button, CircularProgress, Stack, TextField } from '@mui/material';
import AuthShell, {
  authAlertSx,
  authFieldSx,
  authPrimaryButtonSx,
  authSecondaryButtonSx,
} from '../components/auth/AuthShell';

const LoginPage = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const { login, isAuthenticated } = useContext(AuthContext);
  //ホーム画面にリダイレクトする
  const navigate = useNavigate();

  // **ログイン済みならレース一覧にリダイレクト**
  useEffect(() => {
    if (isAuthenticated) {
      navigate('/chiriri_model_race_list');
    }
  }, [isAuthenticated, navigate]);

  //ログイン処理
  const handleLogin = async (e) => {
    e.preventDefault(); // フォームのデフォルトの送信動作を防ぐ
    setError('');
    setLoading(true);
    const success = await login(email, password);
    if (!success) {
      setError('ログインに失敗しました。メールアドレスまたはパスワードを確認してください。');
    }
    setLoading(false);
  };

  return (
    <AuthShell
      eyebrow="Secure Login"
      title="ログイン"
      description="AIレース分析プラットフォームへアクセスします。認証後にレース詳細ダッシュボードと分析機能を利用できます。"
      sideTitle="ちりり競馬"
      sideBody="認証済みユーザーはレース一覧、分析詳細、買い目生成ページへ安全にアクセスできます。"
    >
      <Stack spacing={2.5}>
        {error && (
          <Alert severity="error" onClose={() => setError('')} sx={authAlertSx}>
            {error}
          </Alert>
        )}

        <form onSubmit={handleLogin}>
          <Stack spacing={2}>
            <TextField
              fullWidth
              label="メールアドレス"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              required
              sx={authFieldSx}
            />
            <TextField
              fullWidth
              label="パスワード"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
              sx={authFieldSx}
            />
            <Button fullWidth type="submit" variant="contained" disabled={loading} sx={authPrimaryButtonSx}>
              {loading ? <CircularProgress size={22} sx={{ color: '#04111c' }} /> : 'ログイン'}
            </Button>
          </Stack>
        </form>

        <Box>
          <Button
            fullWidth
            variant="outlined"
            onClick={() => navigate('/usersignupsecret')}
            sx={authSecondaryButtonSx}
          >
            新規会員登録はこちら
          </Button>
        </Box>
      </Stack>
    </AuthShell>
  );
};

export default LoginPage;
